import * as actionTypes from "./types/ordersActionTypes";

export function getOrdersSucceed(data) {
  return {
    type: actionTypes.GET_ORDERS_SUCCEED,
    data
  };
}

export function getOrdersFailed() {
  return {
    type: actionTypes.GET_ORDERS_FAILED
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/ordersActions.js